"use client";

import { LogOut } from "lucide-react";
import { useProfileContext } from "../../../context/ProfileContext";

const Profile = () => {
  const { selectedProfile, logout } = useProfileContext();
  const studentName = selectedProfile?.studentName
    ? selectedProfile.studentName.charAt(0).toUpperCase() +
      selectedProfile.studentName.slice(1)
    : "";

  return (
    <div className="mb-3 text-center">
      <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-4 shadow-xl border border-white/30 transform hover:scale-105 transition-all duration-300">
        <div className="relative flex flex-col items-center gap-2">
          <button
            type="button"
            onClick={logout}
            className="absolute right-0 top-0 flex items-center gap-2 rounded-xl px-3 py-2 font-semibold text-purple-600 transition-colors hover:bg-purple-100 hover:text-purple-800 cursor-pointer"
            aria-label="Log out and return to login"
          >
            <LogOut className="h-5 w-5" />
            <span className="hidden sm:inline">Log out</span>
          </button>
          <div
            className={`text-6xl transition-transform duration-600 hover:scale-110 cursor-pointer`}
          >
            👦
          </div>
          <div className="text-center">
            <h1 className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-1 leading-relaxed pb-1">
              Hello, {studentName}
            </h1>
            <div className="flex items-center justify-center gap-2">
              <span className="text-lg text-gray-700 font-semibold">
                Ready to learn and have fun!
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
